import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Result, Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Inspection from './Inspection';
import { requestInspection } from '../../../state/ui/inspection/inspectionUiActions';
import { selectCurrentInspection, selectInspectionRequest } from '../../../state/ui/inspection/inspectionUiReducer';


function InspectionSkeleton() {
  return (
    <div className="inspection-header" style={{ minHeight: '1000px' }}>
      { /* Estimate an inspection to be about 1000px high. This way we don't have scroll bar flickering when loading an inspection */}
      <div className="via-centre">
        <Spin className="via-centre" />
      </div>
    </div>
  );
}

/**
 * A component for loading and displaying an Inspection.
 * This expects an id from the path to render.
 */
export default function InspectionPage() {
  // Redux
  const dispatch = useDispatch();
  const inspectionRequest = useSelector(selectInspectionRequest);
  const isLoading = inspectionRequest ? inspectionRequest.isLoading : true;
  const loadedInspection = useSelector(selectCurrentInspection);

  // React-Router
  const { id: inspectionCode } = useParams();

  // Load the inspection
  useEffect(() => {
    dispatch(requestInspection(inspectionCode));
  }, [dispatch, inspectionCode]);

  // Not loaded, show a skeleton
  if (isLoading) return <InspectionSkeleton />;

  // Not valid, show a warning
  if (!loadedInspection) {
    return (
      <Result
        status="404"
        title={<FormattedMessage id="inspectionNotFound" />}
        subTitle={<FormattedMessage id="inspectionNotFound" />}
      />
    );
  }

  // Render the loaded inspection
  return <Inspection inspection={loadedInspection} />;
}
